<template>
  <div>
	  <div class="header-height"></div>
	  <div class="header">
	     <div class="title fcc">
			 <slot></slot>
		 </div>
		 <a href="" class="btn-return fcc" @click.prevent="back">
			 <
		 </a>
	  </div>
  </div>
</template>

<script>
export default {
name: 'i-head',
 data() {
	
 	return {
 		
 	}
 },
 methods: {
 	
 },
 
}
</script>

<style scoped="scoped" lang="less">
	.header-height{
		height: 88px;
	}
	.header{
		width: 100%;
		height: 88px;
		position: fixed;
		z-index: 100;
		left: 0;
		top: 0;
		background: rgba(255, 255, 255, 1);
		.title{
			height: 88px;
			color: rgba(0, 0, 0, 1);
			font-size: 30px;
			font-weight: 500;
		}
	}
	
	.btn-return{
		width: 88px;
		height: 88px;
		position: absolute;
		left: 0;
		
		top: 0;
		z-index: 101;
		img{
			width: 21px;
			height: 36px;
			object-fit: contain;
		}
	}
</style>